import React from "react";
import AnimatedText from "../animate/textAnimate";
import { Box, Heading, Text, Image, Card, Flex, Hide } from "@chakra-ui/react";
import myPic from "../img/myPic.jpeg";
import { TbWriting } from "react-icons/tb";
import { themeContext } from "../context/Context";
import { useContext } from "react";
import "./home.css";
const Home = () => {
  let theme = useContext(themeContext);
  let darkmode = theme.state.darkMode;
  return (
    <div className="home" id="Navbar">
      <Flex>
        <Card
          w={["80%", "50%", "60%", "80%"]}
          h={["40%", "50%", "60%", "80%"]}
          m="auto"
          p="3px"
          background="orangered"
          ml={["3rem", "9rem", "12rem", "15rem", "18rem"]}
          style={{
            backgroundColor: darkmode
              ? "rgb(54, 53, 53)"
              : "rgb(217, 235, 252)",
            color: darkmode ? "rgb(240, 231, 231)" : "black",
          }}
          border="5px solid orangered"
        >
          <Box className="Intro" p={"1rem"}>
            <Heading fontSize={["md", "xl", "2xl", "4xl"]}>
              Hi! I am Mitali Sinha
            </Heading>
            <br />
            <Text color="orangered" fontSize={["10px", "15px", "20px", "26px"]}>
              I Build Value Through Design...
            </Text>
            <br />
            {/* <Hide below="sm"> */}
            <Text fontSize={["sm", "md", "lg", "xl"]} margin="auto" w="60%">
              <AnimatedText
                text="A Web Developer, skilled in HTML, CSS , javaScript,
                    react, redux, Node.js, express, mongoDB producing a good quality of web applications."
              />
            </Text>
            {/* </Hide> */}
            <br />
            <br />
            <Image
              src={myPic}
              h={[40, 60, 70, 80]}
              margin="auto"
              borderRadius={"40px"}
            />
          </Box>
        </Card>
        <Image
          src="https://media.tenor.com/uQJyw8sJs5kAAAAM/emoji-emoji-hello.gif"
          h={["30", "40px", "60px", "80px", "100px"]}
          mt={"10rem"}
          mr={["1.5rem", "9rem", "12rem", "15rem", "18rem"]}
          borderRadius={"50%"}
        />
      </Flex>
    </div>
  );
};

export default Home;
